import React, { useEffect, useRef, useState } from "react";

function ProfilePhotoUpload({
  label = "Profile Photo",
  onChange,
  imagePreview,
}) {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    setPreview(imageUrl);

    if (onChange) onChange(file);
  };

  useEffect(() => {
    if (imagePreview) {
      setPreview(imagePreview);
    }
  }, [imagePreview]);

  return (
    <div className="profile-photo-upload">
      <label className="profile-photo-label">{label}</label>

      <div
        className="profile-photo-box"
        onClick={() => fileInputRef.current.click()}
      >
        {preview ? (
          <img src={preview} alt="Profile Preview" />
        ) : (
          <span>Click to upload</span>
        )}
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        hidden
      />
    </div>
  );
}

export default ProfilePhotoUpload;
